import * as vueMounter from "@scripts/vueMounter.ts";
import { commonComponents } from "@scripts/public/common.ts";

vueMounter.mount(commonComponents);
